module.exports = {"id":"205965","name":"Stefan Ristovski","rating":"75","photo":"./data/images/photos/3/205965.png","club":{"name":"Sporting CP","logo":"./data/images/clubs/SportingCP.png"},"positions":["DD","MD"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/StefanRistovski0.json
// module id = 4013
// module chunks = 0